// extracted by mini-css-extract-plugin
module.exports = {"notificationWrapper":"Notification_notificationWrapper__1SGeu","notificationOuterWrapper":"Notification_notificationOuterWrapper__1kbOH"};